import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=40ac4ebe&scoped=true&"
var script = {}
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=40ac4ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac4ebe",
  null
  
)

export default component.exports